import { getCloudinaryUrl } from "@swiggy-private/js-utils";

export const IMAGES = {
    ART_DECO:
        getCloudinaryUrl("portal/static-assets/hcms/dineout/qr/title-text-decoration.png") || "",
    SWIPE: getCloudinaryUrl("portal/static-assets/hcms/dineout/qr/scroll_arrow.png") || "",
};

export const TEXTS = {
    USER_TEXT: "👋 {0}",
};
export const TRUNCATE_LINE = {
    LARGE: 10,
    MEDIUM: 6,
    SMALL: 2,
};

export const ALT_TEXTS = {
    LOGO: "Restaurant logo",
    DECO: "Deco Image",
    SWIPE: "Swipe Icon",
};

export const SIZE = {
    LOGO: "60px",
    X_LARGE: "24px",
    MEDIUM: "16px",
};

export const COLORS = {
    PRIMARY: "#D1A87D",
    SECONDARY: "#FFE6CC99",
    TERTIARY: "#FFE6CC",
};

export const DATA_TEST_IDS = {
    VIEW_MENU_CTA: "view-menu-cta",
};

export const CURTAIN_RAISER = {
    CONSENT_TEXT:
        "By continuing, you agree to sharing your contact details with restaurant and our",
    CONSENT_LINK_TEXT: "Terms & Conditions",
    CONSENT_LINK_URL: "https://www.swiggy.com/terms-and-conditions",
    CONSENT_LINK_TEXT_2: "Privacy Policy",
    CONSENT_LINK_URL_2: "https://www.swiggy.com/privacy-policy",
};
